<template>
    <div>
        <div class="container-fluid white-bg centers-list fr-page">

            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <h1 class="zagolovok">{{ studyProduct.name }}</h1>
                        <p class="text-center">Выберите подходящий абонемент:</p>
                    </div>
                </div>

                <StudyProductSubscriptionList
                        :subscriptions="subscriptions"
                        @order="orderSubscription"
                />

            </div>
        </div>
        <entry/>
    </div>
</template>

<script>
    import studyProductApi from "../../data/StudyProductApi";
    import Entry from "../Entry";
    import StudyProductSubscriptionList from "./landing/StudyProductSubscriptionList";
    import moment from 'moment';

    export default {
        name: "StudyList",
        props: {
            slug: String
        },
        components: {StudyProductSubscriptionList, Entry},
        data() {
            return {
                studyProduct: null,
                subscriptions: [],
                freeSubscription: null,
                loading: false,
                error: null,

            }
        },
        mounted() {
            moment.locale(this.$i18n.locale)
            this.loading = true

            studyProductApi.fetchStudyProductSlug(this.slug)
                .then(response => {
                    this.studyProduct = response
                    this.subscriptions = response.subscriptions.filter(s => {
                        if (s.price <= 0) {
                            this.freeSubscription = s
                            return false
                        }
                        return s.price > 0
                    })
                })
                .catch(error => {
                    let data = error.response.data
                    this.error = this.pretty(data)
                    this.loading = false
                })
        },
        methods: {
            orderSubscription(subscription) {
                this.$router.push('/subscription/order/' + subscription.idsubscription)
            },
        }

    }
</script>

<style scoped>
    .zagolovok {
        text-align: center;
        font-family: Manrope Black;
        font-size: 36px !important;
    }
</style>
